import { Component } from '@angular/core';
import { IconDefinition, faEnvelope, faMobileAlt, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { faInstagram, faFacebook } from '@fortawesome/free-brands-svg-icons';

@Component({
    selector: 'app-footer',
    templateUrl: 'footer.component.html',
    styleUrls: ['footer.component.scss']
})
export class FooterComponent {
    public faMapMarkerAlt: IconDefinition = faMapMarkerAlt;
    public faEnvelope: IconDefinition = faEnvelope;
    public faMobileAlt: IconDefinition = faMobileAlt;
    public faInstagram: IconDefinition = faInstagram;
    public faFacebook: IconDefinition = faFacebook;
}
